import axios from "axios";
import { store, router } from "./main"; // OBS! Samma instanser som appen använder

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

// Request interceptor – sätt token på alla anrop
api.interceptors.request.use(
  (config) => {
    const token = store.state.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor – fånga 401 och 403 (ogiltig/utgången token)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      await store.dispatch("logout"); // vänta på att state nollställs
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
